<div class="image-container" [ngClass]="fitMode">
  <img [ngSrc]="imageSrc" alt="Banner Image" class="image" fill priority />
</div>
